import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Interfaces
export interface RegisterData {
  email: string;
  password: string;
  full_name: string;
}

export interface LoginData {
  email: string;
  password: string;
}

export interface User {
  id: string;
  email: string;
  full_name: string;
  is_admin: boolean;
  email_confirmed: boolean;
}

export interface AuthResponse {
  access_token: string;
  refresh_token: string;
  user: User;
}

// API Methods
export const authApi = {
  // Registrar novo usuário (envia email de confirmação)
  async register(data: RegisterData): Promise<{ message: string }> {
    const response = await api.post('/api/v1/auth/register', data);
    return response.data;
  },

  // Login
  async login(data: LoginData): Promise<AuthResponse> {
    const response = await api.post('/api/v1/auth/login', data);
    return response.data;
  },

  // Verificar email com token
  async verifyEmail(token: string): Promise<AuthResponse> {
    const response = await api.post('/api/v1/auth/verify-email', { token });
    return response.data;
  },

  // Solicitar recuperação de senha
  async forgotPassword(email: string): Promise<{ message: string }> {
    const response = await api.post('/api/v1/auth/forgot-password', { email });
    return response.data;
  },

  // Redefinir senha com token
  async resetPassword(token: string, newPassword: string): Promise<{ message: string }> {
    const response = await api.post('/api/v1/auth/reset-password', { token, new_password: newPassword });
    return response.data;
  },

  // Reenviar email de confirmação
  async resendConfirmation(email: string): Promise<{ message: string }> {
    const response = await api.post('/api/v1/auth/resend-confirmation', { email });
    return response.data;
  },
};
